import axios from "axios";
import { Point } from "geojson";

export type UUID = ReturnType<typeof crypto.randomUUID>;

export interface Position {
  id: number;
  sessionUUID: UUID;
  timestamp: Date;
  position: Point;
  altitude: number | null;
  positionAccuracy: number;
  altitudeAccuracy: number | null;
  heading: number | null;
  speed: number | null;
  floorId: string | null;
  project: string;
}

export interface PositionInsert {
  timestamp: string;
  position: { latitude: number; longitude: number };
  altitude: number | null;
  positionAccuracy: number;
  altitudeAccuracy: number | null;
  heading: number | null;
  speed: number | null;
  floorId: string | null;
  project: string;
}

export class PositionLoggingAPI {
  private readonly host: string;
  private readonly sessionUUID: UUID = crypto.randomUUID();

  constructor(host: string) {
    this.host = host;
    console.warn(
      `Position logging has been enabled. The session UUID is %c${this.sessionUUID}`,
      `color: #76c893; font-weight: bold;`,
    );
  }

  public async getPositions(sessionUUID: UUID): Promise<Position[]> {
    const url = `${this.host}/positions/${sessionUUID}`;
    return axios
      .get<Position[]>(url)
      .then(({ data }) => data)
      .catch(() => []);
  }

  public async postPositions(positons: PositionInsert[]): Promise<boolean> {
    const url = `${this.host}/positions/${this.sessionUUID}`;

    return axios
      .post<Position[]>(url, positons)
      .then(() => true)
      .catch(() => false);
  }
}
